<template>
    <div>
        <v-data-table
            id="actMetersTable"
            :headers="headers"
            :act_date="act_date"
            :items="items"
            item-key="record_id"
            hide-default-footer
            disable-pagination
            disable-sort
            disable-filtering
        >
            <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
                <div :key="index" v-html="header.text"></div>
            </template>
            <template v-slot:item="{ item, index }">
                <tr>
                    <td>{{ item.meter_number }}</td>
                    <td>
                        {{ item.indications }}
                        <br />
                        {{ item.date_action | formatDate }}
                    </td>
                    <td>
                        <v-text-field
                            v-model="item['new_indication']"
                            outlined
                            color="primaryDark"
                            validate-on-blur
                            :rules="shouldValidate(index) ? [validationRules.required] : []"
                            type="number"
                            hide-details
                        />
                        <span v-if="item.new_indication && item.new_indication < item.indications" style="color: red">Не должно быть меньше предыдущих</span>
                    </td>
                    <td>
                        <span v-if="item.is_red_next_meter_verify_date" style="color: red">{{ item.next_meter_verify_date | formatDate }}</span>
                        <span v-else>{{ item.next_meter_verify_date | formatDate }}</span>
                        <br />
                        <span>{{ item.seal_number }}</span>
                    </td>
                    <td>
                        <div class="d-flex flex-column justify-center align-center">
                            <v-file-input
                                @change="handleFileChange(item, index)"
                                accept=".jpg,.jpeg,.pdf"
                                :id="'fileInput_' + index"
                                v-show="false"
                                v-model="item.fileData"
                            >
                            </v-file-input
                            ><v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-btn @click="clickFile(index)" icon v-on="on"><v-icon>mdi-file-document-outline</v-icon></v-btn></template
                                ><span>Загрузить фото</span></v-tooltip
                            >
                            <span v-if="item.photo_selected">
                                <button @click="removeFile(index)" style="color: red; cursor: pointer;">Удалить файл X</button>
                            </span>
                            <span v-if="item.error_msg" style="color: red;">{{ item.error_msg }}</span>
                        </div>
                        <!-- <input type="file" @change="handleFileChange($event, index)" accept=".jpg,.jpeg,.pdf" :id="'fileInput_' + index" />
                        <span v-if="item.photo_selected">
                            <button @click="removeFile(index)" style="color: red; cursor: pointer;">Удалить файл X</button>
                        </span>
                        <span v-if="item.error_msg" style="color: red;">{{ item.error_msg }}</span> -->
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';
import { validationRules } from '@/utils/validationRules';
import { mapActions } from 'vuex';

export default {
    name: 'actMetersTable',
    props: ['items', 'isContract', 'act_date'],
    data: function() {
        return {
            headers: [
                {
                    text: 'Номер ИПУ',
                    value: 'meter_number',
                    width: 50
                },
                {
                    text: 'Последние показания',
                    value: 'indications',
                    width: 50
                },
                {
                    text: 'Новые показания',
                    value: 'new_indication',
                    width: 150
                },
                {
                    text: 'Дата следующей поверки <br> № пломбы',
                    value: 'next_meter_verify_date',
                    width: 170
                },
                {
                    text: 'Загрузить фото',
                    value: 'photo',
                    width: 140
                }
            ]
        };
    },
    computed: {
        validationRules() {
            return validationRules;
        }
    },
    methods: {
        ...mapActions('documents', ['attachmentsTempInsert']),
        async handleFileChange(item, index) {
            if (item.fileData) {
                const file = item.fileData;

                // Проверка формата файла
                const allowedTypes = ['image/jpeg', 'application/pdf'];
                if (!allowedTypes.includes(file.type)) {
                    this.$set(this.items, index, {
                        ...this.items[index],
                        error_msg: 'Неверный формат файла. Допустимые форматы: JPG, JPEG, PDF.',
                        photo_selected: false,
                        photo_name: ''
                    });
                    item.fileData = null;
                    return;
                }

                // Проверка размера файла
                const maxSize = 28 * 1024 * 1024; // 28 MB
                if (file.size > maxSize) {
                    this.$set(this.items, index, {
                        ...this.items[index],
                        error_msg: 'Файл слишком большой. Максимальный размер: 28 MB.',
                        photo_selected: false,
                        photo_name: ''
                    });
                    item.fileData = null;
                    return;
                }

                let formData = new FormData();
                formData.append('file', event.target.files[0]);
                let response = await this.attachmentsTempInsert(formData);
                const attachment_link_rid = response.data.attachment_link_rid;
                item.fileData = null;
                // Если файл прошел все проверки
                this.$set(this.items, index, {
                    ...this.items[index],
                    photo_selected: true,
                    photo_name: file.name,
                    error_msg: '',
                    attachment_link_rid: attachment_link_rid
                });
            }
        },
        clickFile(index) {
            const fileInput = document.getElementById(`fileInput_${index}`);
            fileInput.click();
        },
        resetFileInput(index) {
            this.$refs[`fileInput_${index}`][0].value = '';
        },
        removeFile(index) {
            this.$set(this.items, index, {
                ...this.items[index],
                error_msg: '',
                photo_selected: false,
                photo_name: '',
                attachment_link_rid: null,
                fileData: null
            });
        },
        shouldValidate(index) {
            return (
                (!this.items[index].new_indication && this.items.some(c => c.new_indication || c.attachment_link_rid)) ||
                (this.items[index].new_indication && this.items[index].new_indication < this.items[index].indications)
            );
        }
    }
};
</script>

<style lang="scss">
#actMetersTable tbody {
    tr:hover {
        background-color: transparent !important;
    }
}
.select {
    width: 150px;
}
</style>
